export const ListQueryKey = 'captainsalaries';
export const DetailQueryKey = 'captainsalary';
export const Urls = {
  selectUrl: '/captainsalary/list',
  updateUrl: '/captainsalary/update',
  deleteUrl: '/captainsalary/delete',
  createUrl: '/captainsalary/create',
  detailUrl: '/captainsalary/info'
};